import { useEffect } from 'react';
import posthog from 'posthog-js';
import { toast } from 'react-toastify';

import { useVerifyEmailMutation } from '../../app/services/auth';
import { Dialog } from '../Dialog';
import { ReactComponent as Spinner } from '../../images/spinner.svg';
import { useNavigate } from 'react-router-dom';

function EmailVerification({ verificationToken }) {
    const navigate = useNavigate();
    const [verifyEmail] = useVerifyEmailMutation();

    async function verifyEmailHandler({ verificationToken }) {
        try {
            //Attempt to verify the email
            posthog?.capture('Verifying Email');
            const response = await verifyEmail({ verificationToken });
            if (response?.data?.success) {
                //If the verification is successful, navigate to signin with location state to allow dynamic messaging
                posthog?.capture('Email Verified');
                navigate('/sign-in', { state: { emailVerified: true } });
            }
        } catch (error) {
            toast.error('An error occurred while verifying your email address.');
        }
    }

    useEffect(() => {
        verifyEmailHandler({ verificationToken });
        //eslint-disable-next-line
    }, [verificationToken]);

    return (
        <Dialog>
            <Spinner className="animate-spin" />
            <p className="text-white font-heading text-3xl">Verifying Email</p>
        </Dialog>
    );
}

export default EmailVerification;
